import React from "react";
import "./Hero.scss";
import img_1 from './img_1.jpg';

export default function Hero() {
  return (
    <section className="hero">
      <div className="container hero__inner">
        <div className="hero__text">
          <h1 className="hero__title">Ciņu klubs Top Ring</h1>
          <p className="hero__subtitle">
            Cīņas mākslas klubs “Top Ring” tika dibināts 2019. gadā.
Kluba galvenie virzieni ir Muay Thai un K-1, kā arī klubs piedāvā nodarbības boksā un MMA.
          </p>
          <div className="hero__cta">
            <a className="btn btn--primary" href="/#contact">Pierakstīties uz izmēģinājuma nodarbību</a>
            <a className="btn btn--ghost" href="/#programs">Mūsu programmas</a>
          </div>
        </div>
        <div className="hero__media" aria-hidden>
          {/* <div className="hero__img" /> */}
          <img lassName="hero__img" src={img_1} alt="" />
        </div>
      </div>
    </section>
  );
}
